import React from 'react';
import Reveal from './Reveal';
import SectionLabel from './SectionLabel';

/**
 * The centred section title: numbered kicker, heading, a gold rule that draws
 * itself in, then an optional lead line.
 */
export default function SectionHeading({ index, label, title, lead, tone = 'dark', className = '' }) {
  const isDark = tone === 'dark';

  return (
    <div className={`flex flex-col items-center text-center ${className}`.trim()}>
      {label && (
        <Reveal variant="fade">
          <SectionLabel index={index} tone={tone} align="center" className="mb-7">
            {label}
          </SectionLabel>
        </Reveal>
      )}

      <Reveal
        as="h2"
        delay={80}
        className={`font-display text-[2rem] font-semibold uppercase leading-[1.08] tracking-[0.01em] sm:text-4xl lg:text-[3rem] ${
          isDark ? 'text-ink' : 'text-cream'
        }`}
      >
        {title}
      </Reveal>

      <Reveal variant="rule" delay={220} className="rule mt-6" />

      {lead && (
        <Reveal
          as="p"
          delay={300}
          className={`mt-7 max-w-2xl text-base leading-relaxed sm:text-[1.05rem] ${
            isDark ? 'text-ink/65' : 'text-cream/70'
          }`}
        >
          {lead}
        </Reveal>
      )}
    </div>
  );
}
